export function setToLocalStorage(key: string, value: string) {
	localStorage.setItem(key, value)
}

export function setToSessionStorage(key: string, value: string) {
	sessionStorage.setItem(key, value)
}

export function getFromLocalStorage(key: string): string | undefined {
	return localStorage.getItem(key) || undefined
}

export function getFromSessionStorage<T>(key: string, customDef: T): string | T {
	return sessionStorage.getItem(key) || customDef
}
